import { useState, useEffect, useRef } from "react";
import "./LoginNotif.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApiService from "../../components/Api_services";
import { useContext } from "react";
import { TotalAmountContext } from "../../contexts/TotalAmountContext";
import { MYINVOICE_URL } from "../../constants";

const LoginNotifv2 = ({ onClose }) => {
  const { user } = useSelector((state) => state.auth);
  const { unsuccessfulTotal, overdueTotal, unpaidOrderTotal } =
    useContext(TotalAmountContext);
  const navigate = useNavigate();
  const modalRef = useRef(null);

  // Track if user has closed the notification
  const [hasClosedNotif, setHasClosedNotif] = useState(() => {
    return localStorage.getItem("hasClosedLoginNotif") === "true";
  });

  // Reset hasClosedNotif when user changes (e.g. after login)
  useEffect(() => {
    if (user && !localStorage.getItem("hasClosedLoginNotif")) {
      setHasClosedNotif(false);
    }
  }, [user]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (modalRef.current && !modalRef.current.contains(event.target)) {
  //       onClose();
  //     }
  //   };

  //   // Add event listener
  //   document.addEventListener("mousedown", handleClickOutside);

  //   // Cleanup
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [onClose]);

  // Hide if closed or no overdue
  if (
    hasClosedNotif ||
    (unsuccessfulTotal === 0 && overdueTotal === 0 && unpaidOrderTotal === 0)
  ) {
    return null;
  }

  // Handler for all close actions
  const handleClose = () => {
    setHasClosedNotif(true);
    localStorage.setItem("hasClosedLoginNotif", "true");
    onClose();
  };

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="loginnotif_v2">
      <div className="loginnotif-content_v2" ref={modalRef}>
        <div className="loginnotif-title-container_v2">
          <div className="loginnotif-title_v2">
            <strong>Outstanding Payments</strong>
          </div>
          <button className="close-button_v2" onClick={handleClose}>
            &#10006;
          </button>
        </div>

        <div className="loginnotif-main_v2">
          {(unsuccessfulTotal > 0 ||
            overdueTotal > 0 ||
            unpaidOrderTotal > 0) && (
            <div>
              Welcome back! You have{" "}
              {[
                unsuccessfulTotal > 0 && (
                  <>
                    an <strong>unsuccessful payment</strong> amount of{" "}
                    <strong>RM {formatCurrency(unsuccessfulTotal)}</strong>
                  </>
                ),
                overdueTotal > 0 && (
                  <>
                    an <strong>overdue</strong> amount of{" "}
                    <strong>RM {formatCurrency(overdueTotal)}</strong>
                  </>
                ),
                unpaidOrderTotal > 0 && (
                  <>
                    an <strong>unpaid order</strong> amount of{" "}
                    <strong>RM {formatCurrency(unpaidOrderTotal)}</strong>
                  </>
                ),
              ]
                .filter(Boolean)
                .reduce((acc, item, i, arr) => {
                  if (i === 0) return [item];
                  if (i === arr.length - 1) return [...acc, " and ", item];
                  return [...acc, ", ", item];
                }, [])}
              .
            </div>
          )}
          <div>
            Please make payment at your earliest convenience to maintain a good
            account standing.
          </div>
        </div>

        <div className="loginnotif-sub_v2">
          <button className="paylater_v2" onClick={handleClose}>
            Pay Later
          </button>
          <button
            className="paynow_v2"
            onClick={() => {
              handleClose();
              window.location.href = `${MYINVOICE_URL}?tab=mybill&page=1&type=overduebill`;
            }}
          >
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginNotifv2;
